import React, { useRef, useState } from 'react'
import { Text, View } from 'oio-react'
import * as Sentry from '@sentry/browser'
import AccountContainer from 'src/components/Account/Container'
import { useLocationQuery } from 'src/components/utils'
import { useMe } from 'src/graphql/hooks'
import InvitationAuthenticate from './Authenticate'
import InvitationChooser from './Chooser'
import InvitationError from './Error'
import InvitationVerification from './Verification'

const VERIFICATION_STEP = 'VERIFICATION_STEP'
const AUTHENTICATE_STEP = 'AUTHENTICATE_STEP'
const INVITATION_CHOOSER_STEP = 'INVITATION_CHOOSER_STEP'

const AccountInvitation = () => {
   const { isLoggedIn, loading: userIsLoading } = useMe()

   const { code: invitationCode, email, initiative: initiativeId } = useLocationQuery()
   const targetType = initiativeId ? 'initiative' : 'organization'
   const targetId = initiativeId || 'current'

   const [error, setError] = useState()
   const [currentStepIndex, setCurrentStepIndex] = useState(0)

   // Would be annoying to use state for invitationData
   // because it may not be set before step index is increased.
   // Plus, changes to this do not require a re-render, since
   // this is only required when going back and forward between steps,
   // which is controlled by state changes anyway.
   const invitationData = useRef({})

   const applicableSteps = [
      VERIFICATION_STEP,
      !isLoggedIn ? AUTHENTICATE_STEP : null,
      INVITATION_CHOOSER_STEP
   ].filter(s => s !== null)

   if (userIsLoading) {
      return null
   }

   const currentStep = applicableSteps[currentStepIndex]

   const handleVerificationComplete = (result) => {
      invitationData.current = result
      setCurrentStepIndex(stepIndex => stepIndex + 1)
   }

   const handleVerificationError = (err) => {
      setError(err)
      Sentry.captureException(err)
   }

   return (
      <AccountContainer
         logoutActionMessage="login as someone else"
         overrideLoginCheck>
         <Text size="8[a-d] 9[e-f]" letterSpacing="-0.5px" weight="medium" color="#000">
            Community Invitation
         </Text>
         <View float="left" width="100%" height="12px" />
         {error && (
            <View height="100%" width="100%">
               <InvitationError error={error} />
            </View>
         )}
         {!error && (
            <View height="100%" width="100%">
               {currentStep === VERIFICATION_STEP && (
                  <InvitationVerification
                     email={email}
                     invitationCode={invitationCode}
                     onContinue={handleVerificationComplete}
                     onError={handleVerificationError}
                     targetType={targetType}
                     targetId={targetId}
                  />
               )}
               {currentStep === AUTHENTICATE_STEP && (
                  <InvitationAuthenticate
                     invitationCode={invitationCode}
                     targetType={targetType}
                     targetId={targetId}
                     invitationData={invitationData.current}
                  />
               )}
               {currentStep === INVITATION_CHOOSER_STEP && (
                  <InvitationChooser
                     invitationData={invitationData.current}
                  />
               )}
            </View>
         )}
      </AccountContainer>
   )
}

export default AccountInvitation
